export default class NavigationEvents {
  /**
   * Creates a tracking instance that handles all navigation links
   *
   */
  constructor() {
    this.config = {
      classes: {
        breadcrumbLinks: "Tracking--breadcrumbNavigationLink",
        footerLinks: "Tracking--footerNavigationLink",
        mainLinks: "Tracking--mainNavigationLink",
      },
    };

    this._init();
  }

  /**
   * binds user events
   *
   * @private
   */
  _init() {
    [
      ...document.querySelectorAll(
        `.${this.config.classes.footerLinks}, .${this.config.classes.breadcrumbLinks}, .${this.config.classes.mainLinks}`
      ),
    ].forEach((link) => {
      link.addEventListener("click", () => {
        this._onClickOnNavigationLink(link);
      });
    });
  }

  /**
   * handles click on navigation link
   *
   * @param {HTMLElement} navigationLink
   * @private
   */
  _onClickOnNavigationLink(navigationLink) {
    const isFooter = navigationLink.classList.contains(
      this.config.classes.footerLinks
    );

    const isBreadcrumb = navigationLink.classList.contains(
      this.config.classes.breadcrumbLinks
    );

    const isMain = navigationLink.classList.contains(
      this.config.classes.mainLinks
    );

    let linkSource;

    if (isFooter) {
      linkSource = "footer";
    } else if (isBreadcrumb) {
      linkSource = "breadcrumbs";
    } else if (isMain) {
      linkSource = "main";
    }

    NavigationEvents._dataLayerPush(linkSource, navigationLink.href);
  }

  /**
   * fill out dataLayer object
   *
   * @param {string} eventElement
   * @param {string} navigationPath
   * @private
   */
  static _dataLayerPush(eventElement, navigationPath) {
    window.dataLayer.push({
      event: "Event",
      event_name: `${eventElement}_navigation`,
      [`${eventElement}_navigation`]: {
        navigation_path: navigationPath,

        pp_event_category: "navigation",
        pp_event_action: eventElement,
        pp_event_name: navigationPath,
      },
    });
  }
}
